import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { ServerMediaAsset } from '@/lib/janitsjar/Product';
import Image from 'next/image';
import { extractPlaybackId } from '@/components/newImageCarousel/helpers';
import { PlayIcon } from '@heroicons/react/20/solid';

type CarouselThumbnailProps = {
  active?: boolean;
  onClick: () => void;
  width?: string;
  height?: string;
  media: ServerMediaAsset;
};

export default function CarouselThumbnail({
  width,
  height,
  active = false,
  onClick,
  media,
}: CarouselThumbnailProps) {
  const { type, role } = media;

  const imageUrl =
    type === 'video'
      ? `https://image.mux.com/${extractPlaybackId(
          media.url
        )}/thumbnail.png?width=500&height=500&fit_mode=smartcrop`
      : media.url;

  return (
    <button
      onClick={onClick}
      style={{ width, height }}
      className={twMerge(
        clsx(
          'md:translate-x-0 md:translate-y-0 md:translate-z-0',
          'embla__slide',
          'min-w-0 md:min-h-0 flex-none',
          'bg-neutral-30 rounded-sm overflow-hidden',
          {
            'border-1.5 border-secondary-60': active,
            'p-2': type === 'image' && !role?.startsWith('miljo'),
          }
        )
      )}
    >
      <div className="relative w-full h-full">
        <Image
          src={imageUrl}
          alt="Carousel image"
          fill
          className={twMerge(
            clsx({
              'object-contain mix-blend-darken':
                type === 'image' && !role.startsWith('miljo'),
              'object-cover': type === 'video' || role?.startsWith('miljo'),
            })
          )}
        />
        {type === 'video' && (
          <div className="absolute w-full h-full inset-0 flex justify-center items-center">
            <PlayIcon className="size-[40%] text-white" />
          </div>
        )}
      </div>
    </button>
  );
}
